<template>
    <ImpedimentContainer
        title="MD-Impedimentos Múltiples"
    >
        <p><b>El estudiante presenta:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValidOptionsSelection"
        />

        <p class="disclaimer__text">
            En esta categoría no se incluyen a los estudiantes que presentan sordoceguera, aunque estos presenten varios impedimentos juntos.
        </p>

        <div v-if="!isDisabled" class="d-flex mt-4">
            <div class="impediment-selection__container mt-3">
                <CustomDropDown
                    id="multipleImpediment"
                    v-model="newImpediment"
                    class="w-50 d-inline"
                    label="Impedimentos adicionales:"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="innerSelectableImpediments"
                />
                <div class="d-flex justify-content-end">
                    <ActionButton
                        id="btnAddClick"
                        i="fas fa-file-plus"
                        class="mt-3"
                        variant="success"
                        type="button"
                        :disabled="!newImpediment"
                        @click="addImpediment"
                    >
                        Añadir
                    </ActionButton>
                </div>
            </div>
            <div>
                <CustomChipsGroup
                    title="Impedimentos Seleccionados"
                    no-background
                    object-text="name"
                    object-title="title"
                    object-sub-title="subTitle"
                    :selected-items="innerSelectedImpediments"
                    @itemMarkedForDeletion="$emit('delete-impediment', $event)"
                />
                <Error
                    v-if="showErrors && !isValidImpedimentsCount"
                    class="mt-3"
                    variant="no-border"
                    message="Debe seleccionar al menos 2 impedimentos."
                />
            </div>
        </div>
    </ImpedimentContainer>
</template>
  
<script>
import Error from 'custom-error';
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';
import { 
    CustomChipsGroup,
    CustomDropDown,
    ActionButton
} from '@/components/common';

export default {
    name: 'ImpedimentosMultiples',
    mixins: [ImpedimentMixin],
    components: {
        Error,
        TreeOptions,
        ImpedimentContainer,
        CustomDropDown,
        ActionButton,
        CustomChipsGroup
    },
    props: {
        selectableImpediments: {
            type: Array,
            default: () => []
        },
        selectedImpediments: {
            type: Array,
            default: () => []
        },
    },
    data: () => ({
        showErrors: false,
        newImpediment: null,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        },
        addImpediment() {
            this.$emit('add-impediment', this.newImpediment);
            this.newImpediment = null;
        }
    },
    computed: {
        innerSelectableImpediments() {
            return this.selectableImpediments.filter(x => x.id != this.value.id)
        },
        innerSelectedImpediments() {
            return this.selectedImpediments.filter(x => x.id != this.value.id)
        },
        isValidImpedimentsCount() {
            return this.innerSelectedImpediments.length > 1;
        },
        isValid() {
            return this.isValidOptionsSelection && this.isValidImpedimentsCount;
        },
    },
}
</script>

<style scoped>
.disclaimer__text {
    margin-top: 30px;
    font-weight: bold;
    font-style: italic;
}

.impediment-selection__container {
    width: 25vw;
    padding-right: 20px;
    margin-right: 20px;
    border-right: 1px solid #DEDEDE;
}
</style>